import { AxiosResponse } from "axios";

import { camelizeObject } from "shared/helpers/object";
import { ApiBaseUrl, request } from "shared/clients/baseClient";
import { ExistingBlocks } from "../existingBlocks";

const getExistingBlocks = (
  fieldIdSearch?: string,
  contentTypeFilter: string[] = [],
): Promise<AxiosResponse<ExistingBlocks.ExistingBlock[]>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/questions/`,
      method: "GET",
      params: {
        field_id: fieldIdSearch,
        content_type: contentTypeFilter,
      },
    },
  }).then((data: AxiosResponse<ExistingBlocks.ExistingBlockApi[]>) => {
    return {
      ...data,
      data: data.data?.map(camelizeObject<ExistingBlocks.ExistingBlock>),
    };
  });
};

export const existingBlocksClient = {
  getExistingBlocks,
};
